export const isNullOrEmpty = (value?: string) => value === null || value === undefined || value === ''
